import { Response, jdiColorFetch } from "../colorFetchV2";
import { HappyGroupType, SkuInfoType } from "./happy.types";
import { ACTIVITY_TYPE } from "@/apis/common.types";

export type FetchHappyInfoRespType = Response<HappyGroupType[]>;
type FetchBatchItems = Response<{
  currentPage: number;
  data: SkuInfoType[];
  pageSize: number;
  total: number;
  localInfo: any;
}>;

export type RequestType = {
  activityType: ACTIVITY_TYPE;
  pageSize: number;
  groupId?: string;
  batchId?: number;
};
export const fetchHappyInfo = async (requestData: RequestType): Promise<FetchHappyInfoRespType> => {
  return jdiColorFetch(`marketing_activity_getActivity`, {
    method: "post",
    cache: "no-store",
    bodyQuery: { ...requestData },
  });
};

export const fetchReserveInfo = async (activityType: ACTIVITY_TYPE) => {
  return await jdiColorFetch(`marketing_activity_getReserves`, {
    method: "post",
    cache: "no-store",
    bodyQuery: { activityType },
  })
}


export type SkuRequestType = {
  activityType: ACTIVITY_TYPE;
  groupId: string;
  batchId: number;
  currentPage: number;
  pageSize: number;
};
export const fetchBatchItems = async (requestData: SkuRequestType): Promise<FetchBatchItems> => {
  return jdiColorFetch(`marketing_activity_getItems`, {
    method: "post",
    cache: "no-store",
    bodyQuery: { ...requestData },
  });
};
